import { ref, reactive, Ref, computed } from 'vue'
import Index from './main.vue'
import type { GroupMemberItemUser } from '@teams/common/api/types'

export default Index

type getGroupMemberReturnType = GroupMemberItemUser[]

export const useGroupMemberList = (
  groupId: number,
  {
    list = ref<getGroupMemberReturnType>([]),
    onUpdateMember = () => null
  }: {
    list?: Ref<getGroupMemberReturnType>
    onUpdateMember?: (...args: unknown[]) => void
  } = {}
) => {
  const propList = computed<getGroupMemberReturnType>(() =>
    updateList(list.value)
  )
  const updateList = (data: getGroupMemberReturnType) => {
    return data.map(item => ({
      ...item,
      src: item.avatar
    }))
  }
  const props = ref({
    list: propList,
    groupId,
    onUpdateMember
  })
  return reactive({ props, updateList })
}
